import * as React from 'react';
import ComponentLayout from 'src/components/common/modules/component-layout/component-layout';
import { ComponentLayoutType } from 'src/components/common/modules/component-layout/component-layout';
import { V2ImageModuleComponent } from './code-split/v2-image-module-component';

const V2ImageModule: React.FC<ComponentLayoutType<any>> = (props) => {
  return (
    <ComponentLayout {...props}>
      <V2ImageModuleComponent />
    </ComponentLayout>
  );
};

export default V2ImageModule;
